const renderCoachModal = () => {
  const pageBody = document.querySelector('body');
  const coachModal = document.querySelector('[data-modal="coach-modal"]');
  if (!coachModal) return;

  const modalTitle = coachModal.querySelector('b');
  const modalImage = coachModal.querySelector('img');
  const modalCite = coachModal.querySelector('q');
  const modalText = coachModal.querySelector('.coaching__modal-text');

  const onCardClick = (evt) => {
    if (evt.target.closest('[data-coach-card]')) {
      const targetCard = evt.target.closest('[data-coach-card]');
      const cardName = targetCard.querySelector('b').textContent;
      const cardImage = targetCard.querySelector('img');
      const cardCite = targetCard.querySelector('q').textContent;
      const cardInfo = targetCard.querySelector('.coaching__text').outerHTML;
      
      modalTitle.textContent = cardName;
      modalImage.src = cardImage.src;
      modalImage.alt = cardImage.alt;
      modalCite.textContent = cardCite;
      modalText.innerHTML = cardInfo;
    }
  };

  pageBody.addEventListener('click', onCardClick);
};

export default renderCoachModal;
